import ajax from './index'
import apiEnv from './apiEnv'
// 优惠券列表
export function couponsList(data) {
    return ajax.post(`${apiEnv.api1}/api/Admin/AccountCouponConfig/ListCouponConfig`, data)
}
//添加优惠券配置||发布
export function couponsConfig(data) {
    return ajax.post(`${apiEnv.api1}/api/Admin/AccountCouponConfig/AddCouponConfig`, data)
}

// 个人列表
export function personalList(data) {
    return ajax.post(`${apiEnv.api1}/api/Admin/AccountCouponConfig/ListCouponUser`, data)
}
//企业列表
export function enterpriseList(data) {
    return ajax.post(`${apiEnv.api1}/api/Admin/AccountCouponConfig/ListCouponCompany`, data)
}
//获取地址数据
export function getAreaDataByParent(data) {
    return ajax.post(`${apiEnv.api1}/api/BpoJobAddress/GetAreaDataByParent`, data)
}
//添加用户
export function addCouponAccount(data) {
    return ajax.post(`${apiEnv.api1}/api/Admin/AccountCouponConfig/AddCouponAccount`, data)
}
//删除用户
export function deleteCouponAccount(data) {
    return ajax.post(`${apiEnv.api1}/api/Admin/AccountCouponConfig/DeleteCouponAccount`, data)
}
//获取核销统计表列表数据
export function getAdminCouponStatisticsList(data) {
    return ajax.post(`${apiEnv.api1}/api/Admin/AccountCoupon/GetAdminCouponStatisticsList`, data)
}
